import React, { useState, useEffect } from "react";

import QRCode from "react-qr-code";

import VuiBox from "components/VuiBox";
import VuiButtonCustom from "components/VuiButtonCustom";
import VuiLabel from "components/VuiLabel";
import VuiModal from "components/VuiModal";
import colors from "assets/theme/base/colors";

import { InfoUserLogs } from "./components/InfoUserLogs";

import moment from "moment";

import {
  DashboardGrid,
  DashboardGridQrCode,
  ServerHeader,
  ServerName,
  ServerDomain,
  ServerStatus,
  ServerStatusHeader,
  ServerStatusOnline,
  ServerStatusOffline,
  InfoRow,
  QrCodeRow,
  QrCodeLabel,
  InfoLabel,
  InfoValue,
} from "./styles";

function rulesHostNameColor(hostname) {
  if (hostname.substr(0, 3) === "NT-" || hostname.substr(0, 3) === "PC-") {
    return "#0f1535";
  }
  return "#bd0000";
}

function macToId(mac) {
  // 1-F44D-308C-BC64-1
  //   0123-4567-8901
  let blocksMac = mac.split(":");

  console.log(">>>", blocksMac);

  blocksMac =
    blocksMac[0] +
    blocksMac[1] +
    "-" +
    blocksMac[2] +
    blocksMac[3] +
    "-" +
    blocksMac[4] +
    blocksMac[5];

  console.log(">>>", blocksMac);

  return "1-" + blocksMac.toLowerCase() + "-1";
}

function VuiInfoItemStations({ item, index, qrcode }) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  if (item) {
    if (qrcode) {
      console.log("", item.isNormativeInstruction);
      if (item.isNormativeInstruction === 1) {
        return (
          <DashboardGridQrCode>
            <QrCodeRow>
              <QRCode
                size={180}
                value={`https://monitor.seap.ma.gov.br/support?${macToId(item?.macAddress)}`}
              />
              <QrCodeLabel color={rulesHostNameColor(item?.hostname)}>{item?.hostname}</QrCodeLabel>
            </QrCodeRow>
          </DashboardGridQrCode>
        );
      } else {
        return null;
      }
    } else {
      return (
        <>
          <VuiModal
            isOpen={isOpenModal}
            onClose={() => {
              setIsOpenModal(!isOpenModal);
            }}
          >
            <InfoUserLogs
              item={item.users}
              onClose={() => {
                setIsOpenModal(!isOpenModal);
              }}
            />
          </VuiModal>
          <DashboardGrid>
            <ServerHeader>
              <ServerStatusHeader>
                <ServerName color={rulesHostNameColor(item?.hostname)}>{item?.hostname}</ServerName>
                <ServerDomain>seap.ma.br</ServerDomain>
              </ServerStatusHeader>

              <ServerStatus>
                {item.status === 1 ? (
                  <ServerStatusOnline>Online</ServerStatusOnline>
                ) : (
                  <ServerStatusOffline>Offline</ServerStatusOffline>
                )}
              </ServerStatus>
            </ServerHeader>

            <InfoRow>
              <InfoLabel>SO:</InfoLabel>
              <InfoValue>
                {typeof item.properties === "object"
                  ? item?.properties?.operationSystem.replace("Microsoft Windows", "Windows ")
                  : ""}
              </InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>IP:</InfoLabel>
              <InfoValue>{item?.ipAddress}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>MAC:</InfoLabel>
              <InfoValue>{item?.macAddress}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Fabricante:</InfoLabel>
              <InfoValue>{item?.brandName}</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>Modelo:</InfoLabel>
              <InfoValue>{item?.modelName}</InfoValue>
            </InfoRow>

            {typeof item.properties === "object" ? (
              <>
                <InfoRow>
                  <InfoLabel>CPU:</InfoLabel>
                  <InfoValue>{item?.properties?.cpuModel}</InfoValue>
                </InfoRow>

                <InfoRow>
                  <InfoLabel>Total Memória RAM:</InfoLabel>
                  <InfoValue>{Math.round(item?.properties?.totalMemoryRam)} GB</InfoValue>
                </InfoRow>

                <InfoRow>
                  <InfoLabel>Discos:</InfoLabel>
                </InfoRow>
                <InfoRow>
                  <InfoLabel></InfoLabel>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {item?.properties?.infoDisks.map((x) => (
                      <>
                        <InfoValue>
                          Unidade:<strong>{x.drive}</strong> Capacidade:<strong>{x.size}</strong>GB
                          - Livre: <strong>{x.free}</strong>GB
                        </InfoValue>
                      </>
                    ))}
                  </div>
                </InfoRow>

                <InfoRow>
                  <InfoLabel>AnyDesk ID:</InfoLabel>
                  {item?.properties?.anyDeskId !== 0 ? (
                    <a href={`anydesk://${item?.properties?.anyDeskId}`}>
                      {item?.properties?.anyDeskId}
                    </a>
                  ) : (
                    <InfoValue>
                      {item?.properties?.anyDeskId === 0
                        ? item?.properties?.anyDeskInstall
                        : item?.properties?.anyDeskId}
                    </InfoValue>
                  )}
                </InfoRow>

                <InfoRow>
                  <InfoLabel>RustDesk ID:</InfoLabel>
                  <InfoValue>
                    {item?.properties?.rustDeskId === 0
                      ? item?.properties?.rustDeskInstall
                      : item?.properties?.rustDeskId}
                  </InfoValue>
                </InfoRow>
              </>
            ) : null}

            <VuiLabel />

            <VuiButtonCustom
              title="Acessos"
              color="secondary"
              fontWeight="bold"
              icon="group"
              iconSide="left"
              onClick={() => {
                setIsOpenModal(!isOpenModal);
              }}
            />
          </DashboardGrid>
        </>
      );
    }
  } else {
    return <></>;
  }
}

export default VuiInfoItemStations;
